import Accordion from "@/common/components/Accordion"
import { CompanyData } from "@/features/companies/types/companies.type"
import { CircleChevronDownIcon } from "lucide-react"
import { UpdateSupplyPoliticsModal } from "../../../Update/components/UpdateSupplyPoliticsModal"
import { strategy as consumptionPasswordRestrictionsStrategy } from '@/features/privateCompanies/constants/consumptionPasswordRestrictions.constant'

export const SupplySection = ({ company }: { company: CompanyData | undefined }) => {
    return (
        <Accordion
            defaultOpen
            head={(
                <div className="flex items-center gap-x-3">
                    <div onClick={(e) => e.stopPropagation()}>
                        <UpdateSupplyPoliticsModal company={company} />
                    </div>

                    <p className='text-xl'>
                        Políticas de abastecimento
                    </p>
                </div>
            )}
            triggerClassName="py-0"
            bodyClassName="pt-4 pb-0"
            body={
                <div>
                    <div className="flex items-center gap-x-2 text-white">
                        <p>Configuração da senha para consumo com cartão (APP Condutor):</p>
                        <div className='flex items-center gap-1 text-white-400'>
                            <CircleChevronDownIcon strokeWidth={1.5} />
                            <p>
                                {consumptionPasswordRestrictionsStrategy[company?.consumption_password_update_restriction as keyof typeof consumptionPasswordRestrictionsStrategy]}
                            </p>
                        </div>
                    </div>
                </div>
            }
        />
    )
}

export default SupplySection
